import {
  LinearProgress,
  LinearProgressProps,
  linearProgressClasses,
  useTheme
} from "@mui/material";

interface StyledBorderLinearProgressProps extends LinearProgressProps {
  capacity: number;
  minRate: number;
  maxRate: number;
}

export function StyledBorderLinearProgress({
  capacity,
  minRate,
  maxRate,
  sx,
  ...rest
}: Readonly<StyledBorderLinearProgressProps>) {
  const theme = useTheme();

  return (
    <LinearProgress
      {...rest}
      sx={{
        [`&.${linearProgressClasses.colorPrimary}`]: {
          backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 700]
        },
        [`& .${linearProgressClasses.bar}`]: {
          borderRadius: 5,
          backgroundColor: capacity < minRate || capacity > maxRate ? "red" : "green"
        },
        ...sx // allow additional overrides
      }}
    />
  );
}
